module.exports = __webpack_public_path__ + "img/anli-6.4a784099.png";